// Firebase configuration loaded from environment variables
// Configuration is set via .env files (see .env.example for setup)

/**
 * Build Firebase configuration from environment variables
 * Parcel will inline these values at build time based on the active .env file
 */
function buildFirebaseConfig() {
  // Access environment variables directly with fallbacks to prevent build errors
  const FIREBASE_API_KEY = process.env.FIREBASE_API_KEY || '';
  const FIREBASE_AUTH_DOMAIN = process.env.FIREBASE_AUTH_DOMAIN || '';
  const FIREBASE_PROJECT_ID = process.env.FIREBASE_PROJECT_ID || '';
  const FIREBASE_STORAGE_BUCKET = process.env.FIREBASE_STORAGE_BUCKET || '';
  const FIREBASE_MESSAGING_SENDER_ID = process.env.FIREBASE_MESSAGING_SENDER_ID || '';
  const FIREBASE_APP_ID = process.env.FIREBASE_APP_ID || '';
  const FIREBASE_USE_EMULATOR = process.env.FIREBASE_USE_EMULATOR || '';
  const FIREBASE_FUNCTIONS_EMULATOR_HOST = process.env.FIREBASE_FUNCTIONS_EMULATOR_HOST || '';

  const config = {
    apiKey: FIREBASE_API_KEY,
    authDomain: FIREBASE_AUTH_DOMAIN,
    projectId: FIREBASE_PROJECT_ID,
    storageBucket: FIREBASE_STORAGE_BUCKET,
    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
    appId: FIREBASE_APP_ID
  };

  // Add emulator settings if enabled
  if (FIREBASE_USE_EMULATOR === 'true') {
    config.useEmulator = true;
    config.functionsEmulatorHost = FIREBASE_FUNCTIONS_EMULATOR_HOST || 'localhost:5001';
  }

  return config;
}

/**
 * Get the current environment name based on NODE_ENV and hostname
 * This is primarily for logging/debugging purposes
 */
export function getEnvironment() {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local (emulator)';
  }
  
  if (hostname.includes('staging') || hostname.includes('stag')) {
    return 'staging';
  }
  
  if (hostname.includes('dev')) {
    return 'development';
  }
  
  // Production for everything else
  return 'production';
}

/**
 * Get Firebase configuration
 * Configuration is automatically loaded from the appropriate .env file:
 * - .env (base/emulator) - loaded by default
 * - .env.development - loaded when NODE_ENV=development
 * - .env.production - loaded when NODE_ENV=production
 * - .env.staging - loaded when NODE_ENV=staging (requires manual NODE_ENV setting)
 */
export function getFirebaseConfig() {
  const config = buildFirebaseConfig();
  const env = getEnvironment();
  console.log(`Firebase environment: ${env}`);
  console.log(`Firebase project: ${config.projectId}`);
  return config;
}